import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "login-main" }
const _hoisted_4 = { class: "login-main-header" }
const _hoisted_5 = {
  class: "animate__animated animate__fast animate__fadeInDown",
  style: {"animation-delay":"0.1s"}
}
const _hoisted_6 = {
  class: "animate__animated animate__fast animate__fadeInUp",
  style: {"animation-delay":"0.2s"}
}
const _hoisted_7 = {
  class: "animate__animated animate__fast animate__fadeInDown",
  style: {"animation-delay":"0.1s"}
}
const _hoisted_8 = {
  class: "animate__animated animate__fast animate__fadeInUp",
  style: {"animation-delay":"0.2s"}
}
const _hoisted_9 = {
  class: "animate__animated animate__fast animate__fadeInDown",
  style: {"animation-delay":"0.1s"}
}
const _hoisted_10 = {
  class: "animate__animated animate__fast animate__fadeInUp",
  style: {"animation-delay":"0.2s"}
}
const _hoisted_11 = {
  class: "animate__animated animate__fast animate__fadeInDown",
  style: {"animation-delay":"0.1s"}
}
const _hoisted_12 = {
  class: "animate__animated animate__fast animate__fadeInUp",
  style: {"animation-delay":"0.2s"}
}
const _hoisted_13 = { class: "login-main-form" }
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger p-2 pr-3 pl-3 font-w-600 animate__animated animate__fast animate__shakeX d-flex align-items-center",
  style: {"gap":"6px"}
}
const _hoisted_15 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"height":"16px"},
  viewBox: "0 0 512 512"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
}, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "alert alert-success p-2 pr-3 pl-3 font-w-600 animate__animated animate__fast animate__zoomIn d-flex align-items-center",
  style: {"gap":"6px"}
}
const _hoisted_19 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"height":"16px"},
  viewBox: "0 0 512 512"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z"
}, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "login_username" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback mt-2"
}
const _hoisted_26 = { class: "form-group password-field" }
const _hoisted_27 = { for: "login_password" }
const _hoisted_28 = ["type"]
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback mt-2"
}
const _hoisted_30 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M288 64c-140.8 0-229.3 128-256 192 26.7 64 115.2 192 256 192 140.8 0 229.3-128 256-192-26.7-64-115.2-192-256-192zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6-14.9 35.7-46.2 87.7-93 131.1-47.1 43.7-111.8 80.6-192.6 80.6S142.5 443.2 95.4 399.4c-46.8-43.5-78.1-95.4-93-131.1-3.3-7.9-3.3-16.7 0-24.6 14.9-35.7 46.2-87.7 93-131.1zM288 352c53 0 96-43 96-96 0-43.3-28.7-79.9-68.1-91.9 2.7 8.8 4.1 18.2 4.1 27.9 0 53-43 96-96 96-9.7 0-19.1-1.4-27.9-4.1 11.9 39.4 48.6 68.1 91.9 68.1zM160.2 263.8c-.2-2.6-.2-5.2-.2-7.8 0-12.2 1.7-23.9 4.9-35 .3-.9 .5-1.8 .8-2.7 12.4-40.4 44.3-72.2 84.7-84.7 11.9-3.7 24.6-5.6 37.7-5.6 2.5 0 5 .1 7.4 .2l.4 0c67.1 4 120.2 59.7 120.2 127.8 0 70.7-57.3 128-128 128-68.1 0-123.8-53.2-127.8-120.2zm32.1-16.1c9.3 5.3 20.1 8.4 31.6 8.4 35.3 0 64-28.7 64-64 0-11.5-3-22.3-8.4-31.6-46.4 4-83.3 40.9-87.3 87.3z"
}, null, -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M27.3-27.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l544 544c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L466.4 411.9c4.9-4.1 9.6-8.2 14.1-12.5 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-60 0-111.1 20.3-152.8 48.7L27.3-27.2zm131 131c36.4-23.7 79.7-39.8 129.7-39.8 140.8 0 229.3 128 256 192-13.3 32-42.1 80-85.2 120-4.9 4.5-9.9 8.9-15.1 13.2l-54.6-54.6c16.9-21.7 26.9-48.9 26.9-78.5 0-70.7-57.3-128-128-128-29.6 0-56.9 10-78.5 26.9l-51.2-51.2zM366.2 311.7L232.3 177.8c15.7-11.2 34.9-17.8 55.7-17.8 53 0 96 43 96 96 0 20.8-6.6 40-17.8 55.7zM74.8 133.3c-35.5 38.5-59.7 80.2-72.3 110.4-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6 40.6 0 77.1-9.3 109.4-24.1L373 431.5c-25.8 10.3-54.1 16.5-85 16.5-140.8 0-229.3-128-256-192 11.2-26.8 33.2-64.9 65.4-100.1L74.8 133.3z"
}, null, -1 /* HOISTED */)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "form-group text-right" }
const _hoisted_37 = {
  key: 0,
  class: "form-group"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 1,
  class: "form-group login-with"
}
const _hoisted_41 = { class: "login-with-login-title" }
const _hoisted_42 = { class: "login-with-login-buttons" }
const _hoisted_43 = {
  key: 0,
  class: "d-flex justify-content-center align-items-end mb-3",
  style: {"gap":"10px"}
}
const _hoisted_44 = ["onClick", "disabled", "tooltip"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 2,
  class: "text-center sign-up-message"
}
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = { for: "forgot_username" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = {
  key: 0,
  class: "invalid-feedback mt-2"
}
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = { for: "login_username" }
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = {
  key: 0,
  class: "invalid-feedback mt-2"
}
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "form-group" }
const _hoisted_67 = { for: "signup_fullname" }
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = {
  key: 0,
  class: "invalid-feedback mt-2"
}
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = { for: "signup_email" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = {
  key: 0,
  class: "invalid-feedback mt-2"
}
const _hoisted_74 = {
  key: 0,
  class: "form-group"
}
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "text-center sign-up-message" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "login-footer" }, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: $options.logo,
        alt: "Mini ERP"
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($data.view === 'login')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString($setup.frappe._('Welcome Back')) + " 👋", 1 /* TEXT */),
              _createElementVNode("p", _hoisted_6, _toDisplayString($setup.frappe._('Sign in to your account and start your work.')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.view === 'forgot')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString($setup.frappe._('Forgot Password?')) + " 🔒", 1 /* TEXT */),
              _createElementVNode("p", _hoisted_8, _toDisplayString($setup.frappe._('Enter your email address and we will send you a link to reset your password.')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.view === 'signup' && !$setup.minierp.disable_signup)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString($setup.frappe._('Create Your Account')) + " 🚀", 1 /* TEXT */),
              _createElementVNode("p", _hoisted_10, _toDisplayString($setup.frappe._('Enter your personal details to create account.')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.view === 'login-link')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("h3", _hoisted_11, _toDisplayString($setup.frappe._('Login with Email Link')) + " 📩", 1 /* TEXT */),
              _createElementVNode("p", _hoisted_12, _toDisplayString($setup.frappe._('Enter your email address and we will send you a link to login.')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        ($data.error_message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17)),
              _createTextVNode(" " + _toDisplayString($data.error_message), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.success_message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21)),
              _createTextVNode(" " + _toDisplayString($data.success_message), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.view === 'login')
          ? (_openBlock(), _createElementBlock("form", {
              key: 2,
              onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.login && $options.login(...args)), ["prevent"])),
              class: "animate__animated animate__faster animate__zoomIn",
              style: {"animation-delay":"0.2s"}
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString($setup.frappe._($setup.minierp.login_label)), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control form-control-lg animate__animated animate__fast", {'is-invalid animate__shakeX': $data.errors.login_username}]),
                  id: "login_username",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.login_username) = $event)),
                  placeholder: $setup.minierp.login_name_placeholder,
                  autocomplete: "username"
                }, null, 10 /* CLASS, PROPS */, _hoisted_24), [
                  [_vModelText, $data.login_username]
                ]),
                ($data.errors.login_username)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($data.errors.login_username), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString($setup.frappe._('Password')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: $data.show_password ? 'text' : 'password',
                  class: _normalizeClass(["form-control form-control-lg animate__animated animate__fast", {'is-invalid animate__shakeX': $data.errors.login_password}]),
                  id: "login_password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.login_password) = $event)),
                  placeholder: "•••••",
                  autocomplete: "current-password"
                }, null, 10 /* CLASS, PROPS */, _hoisted_28), [
                  [_vModelDynamic, $data.login_password]
                ]),
                ($data.errors.login_password)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($data.errors.login_password), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: "toggle-password",
                  onClick: _cache[2] || (_cache[2] = $event => ($data.show_password = !$data.show_password))
                }, [
                  (!$data.show_password)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32))
                    : _createCommentVNode("v-if", true),
                  ($data.show_password)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_35))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("a", {
                  class: _normalizeClass(["cursor-pointer", {'cursor-not-allowed': $data.loading}]),
                  onClick: _cache[3] || (_cache[3] = $event => ($options.change_view('forgot')))
                }, _toDisplayString($setup.frappe._('Forgot Password?')), 3 /* TEXT, CLASS */)
              ]),
              (!$setup.minierp.disable_user_pass_login)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["btn btn-primary btn-block waves-effect waves-light", { 'loading': $data.loading }]),
                      disabled: $data.loading
                    }, [
                      (!$data.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString($setup.frappe._('Login')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_38)
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.minierp.login_with_email_link || $setup.minierp.social_login)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", null, _toDisplayString($setup.frappe._('Or')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      ($setup.minierp.provider_logins?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.minierp.provider_logins, (provider) => {
                              return (_openBlock(), _createElementBlock("button", {
                                type: "button",
                                onClick: $event => ($options.login_with_provider(provider)),
                                disabled: $data.loading,
                                tooltip: $setup.frappe._('Login with {0}', [provider.provider_name]),
                                class: "btn btn-default btn-icon btn-block"
                              }, [
                                _createElementVNode("span", {
                                  innerHTML: provider.icon || provider.provider_name
                                }, null, 8 /* PROPS */, _hoisted_45)
                              ], 8 /* PROPS */, _hoisted_44))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.minierp.login_with_email_link)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: _cache[4] || (_cache[4] = $event => ($options.change_view('login-link'))),
                            disabled: $data.loading,
                            class: "btn btn-default btn-block waves-effect waves-gray"
                          }, _toDisplayString($setup.frappe._('Login with Email Link')), 9 /* TEXT, PROPS */, _hoisted_46))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!$setup.minierp.disable_signup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createTextVNode(_toDisplayString($setup.frappe._("Don't have an account?")) + " ", 1 /* TEXT */),
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = $event => ($options.change_view('signup'))),
                      class: _normalizeClass(["cursor-pointer text-primary", {'cursor-not-allowed': $data.loading}]),
                      style: {"font-weight":"600"}
                    }, _toDisplayString($setup.frappe._("Sign up")), 3 /* TEXT, CLASS */)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true),
        ($data.view === 'forgot')
          ? (_openBlock(), _createElementBlock("form", {
              key: 3,
              onSubmit: _cache[9] || (_cache[9] = _withModifiers((...args) => ($options.forgot_password && $options.forgot_password(...args)), ["prevent"])),
              class: "animate__animated animate__faster animate__zoomIn"
            }, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, _toDisplayString($setup.frappe._('Email Address')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: _normalizeClass(["form-control form-control-lg animate__animated animate__fast", {'is-invalid animate__shakeX': $data.errors.forgot_username}]),
                  id: "forgot_username",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.forgot_username) = $event)),
                  placeholder: $setup.minierp.login_name_placeholder,
                  autocomplete: "username"
                }, null, 10 /* CLASS, PROPS */, _hoisted_50), [
                  [_vModelText, $data.forgot_username]
                ]),
                ($data.errors.forgot_username)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString($data.errors.forgot_username), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  type: "submit",
                  class: _normalizeClass(["btn btn-primary btn-block waves-effect waves-light", { 'loading': $data.loading }]),
                  disabled: $data.loading
                }, [
                  (!$data.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString($setup.frappe._('Reset Password')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_53)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = $event => ($options.change_view('login'))),
                  disabled: $data.loading,
                  class: "btn btn-link text-primary btn-block waves-effect waves-gray box-shadow-none border-none"
                }, _toDisplayString($setup.frappe._('Back to Login')), 9 /* TEXT, PROPS */, _hoisted_56)
              ])
            ], 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true),
        ($data.view === 'login-link')
          ? (_openBlock(), _createElementBlock("form", {
              key: 4,
              onSubmit: _cache[12] || (_cache[12] = _withModifiers((...args) => ($options.login_link && $options.login_link(...args)), ["prevent"])),
              class: "animate__animated animate__faster animate__zoomIn"
            }, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("label", _hoisted_58, _toDisplayString($setup.frappe._('Email Address')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: _normalizeClass(["form-control form-control-lg animate__animated animate__fast", {'is-invalid animate__shakeX': $data.errors.login_username}]),
                  id: "login_username",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.login_username) = $event)),
                  placeholder: $setup.minierp.login_name_placeholder,
                  autofocus: "",
                  autocomplete: "username"
                }, null, 10 /* CLASS, PROPS */, _hoisted_59), [
                  [_vModelText, $data.login_username]
                ]),
                ($data.errors.login_username)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString($data.errors.login_username), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", {
                  type: "submit",
                  class: _normalizeClass(["btn btn-primary btn-block waves-effect waves-light", { 'loading': $data.loading }]),
                  disabled: $data.loading
                }, [
                  (!$data.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString($setup.frappe._('Send login link')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_62)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = $event => ($options.change_view('login'))),
                  disabled: $data.loading,
                  class: "btn btn-link text-primary btn-block waves-effect waves-gray box-shadow-none border-none"
                }, _toDisplayString($setup.frappe._('Back to Login')), 9 /* TEXT, PROPS */, _hoisted_65)
              ])
            ], 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true),
        ($data.view==='signup' && !$setup.minierp.disable_signup)
          ? (_openBlock(), _createElementBlock("form", {
              key: 5,
              onSubmit: _cache[16] || (_cache[16] = _withModifiers((...args) => ($options.signup && $options.signup(...args)), ["prevent"])),
              class: "animate__animated animate__faster animate__zoomIn"
            }, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("label", _hoisted_67, _toDisplayString($setup.frappe._('Full Name')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control form-control-lg animate__animated animate__fast", {'is-invalid animate__shakeX': $data.errors.signup_fullname}]),
                  id: "signup_fullname",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($data.signup_fullname) = $event)),
                  placeholder: $setup.frappe._('Abdo Hamoud'),
                  autofocus: "",
                  autocomplete: "name"
                }, null, 10 /* CLASS, PROPS */, _hoisted_68), [
                  [_vModelText, $data.signup_fullname]
                ]),
                ($data.errors.signup_fullname)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString($data.errors.signup_fullname), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("label", _hoisted_71, _toDisplayString($setup.frappe._('Email')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: _normalizeClass(["form-control form-control-lg animate__animated animate__fast", {'is-invalid animate__shakeX': $data.errors.signup_email}]),
                  id: "signup_email",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.signup_email) = $event)),
                  placeholder: $setup.minierp.login_name_placeholder,
                  autocomplete: "username"
                }, null, 10 /* CLASS, PROPS */, _hoisted_72), [
                  [_vModelText, $data.signup_email]
                ]),
                ($data.errors.signup_email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString($data.errors.signup_email), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              (!$setup.minierp.disable_user_pass_login)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["btn btn-primary btn-block waves-effect waves-light", { 'loading': $data.loading }]),
                      disabled: $data.loading
                    }, [
                      (!$data.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString($setup.frappe._('Sign up')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_75)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_77, [
                _createTextVNode(_toDisplayString($setup.frappe._("Have an account?")) + " ", 1 /* TEXT */),
                _createElementVNode("a", {
                  onClick: _cache[15] || (_cache[15] = $event => ($options.change_view('login'))),
                  class: _normalizeClass(["cursor-pointer text-primary", {'cursor-not-allowed': $data.loading}]),
                  style: {"font-weight":"600"}
                }, _toDisplayString($setup.frappe._("Login")), 3 /* TEXT, CLASS */)
              ])
            ], 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _hoisted_78
  ]))
}